export function treeToList(tree, key = 'childHisMenus') {
  const list = []

  function traverse(node) {
    const data = JSON.parse(JSON.stringify(node))
    data[key] = []
    list.push(data)

    if (Array.isArray(node[key]) && node[key].length > 0) {
      node[key].forEach(traverse)
    }
  }

  tree.forEach(traverse)

  return list
}
